import React, { useState, useCallback } from "react";
import { Link } from "react-router-dom";
import Icon from "../../ui/Icon";
import ConfirmModal from "../modal/ConfirmModal";
import FormModal from "../modal/FormModal";

const Dropdown = ({ align = "start", className, buttonIconSize, buttonIcon, buttonLabel, list }) => {

    switch (buttonIconSize) {
        case "xs":
            buttonIconSize = "14px";
            break;
        case "sm":
            buttonIconSize = "16px";
            break;
        case "md":
            buttonIconSize = "20px";
            break;
        case "lg":
            buttonIconSize = "24px";
            break;
        default:
            buttonIconSize = "20px";
    }

    const [modalOpen, setModalOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const hasBGColorClass = /(^|\s)bg-(?!opacity)/.test(className);
    const bgClass = hasBGColorClass ? "" : " bg-dark";
    const displayClass = className && className.includes("d-") ? "" : " d-flex align-items-center gap-2";
    const classes = `btn${bgClass}${className ? " " + className : ""}${displayClass} fw-medium border-0 rounded-pill`;

    const openModal = useCallback((item) => {
        setSelectedItem(item);
        setModalOpen(true);
    }, []);

    const confirmModal = useCallback(() => {
        selectedItem.clickHandler(selectedItem);
        setModalOpen(false);
        setSelectedItem(null); // Clear out the selected item once the action is confirmed
    }, [selectedItem]);

    const cancelModal = useCallback(() => {
        setModalOpen(false);
        setSelectedItem(null); // Clear out the selected item if the action is cancelled
    }, []);

    const formModalSubmit = useCallback((data) => {
        selectedItem.clickHandler(data);
        setModalOpen(false);
        setSelectedItem(null);
    }, [selectedItem]);

    const renderItemContent = (item) => (
        <>
            {item.icon && <Icon name={item.icon} width="14px" fill={item.active ? "dark" : ""} />}
            {item.label && item.label}
        </>
    );

    return (
        list && (
            <div className={`dropdown${align === 'center' ? "-center" : ""}`}>
                <button className={classes}
                        data-bs-toggle="dropdown"
                        aria-expanded="false">
                    {buttonIcon && <Icon name={buttonIcon} width={buttonIconSize} />}
                    {buttonLabel && <span className="text-body fs-md">{buttonLabel}</span>}
                </button>
                <ul className={`dropdown-menu dropdown-menu-${align}`}>
                    {list.map((item, index) => (
                        <li key={index}>
                            {item.link ? (
                                <Link to={item.link} className={`dropdown-item d-flex align-items-center rounded-1 text-capitalize gap-2${item.active ? " active" : ""}`}>
                                    {renderItemContent(item)}
                                </Link>
                            ) : (
                                <>
                                    <button
                                        onClick={item.confirm ? () => openModal(item) : item.form ? () => openModal(item) : () => item.clickHandler(item)}
                                        className={`dropdown-item d-flex align-items-center rounded-1 text-capitalize gap-2${item.active ? " active" : ""}`}>
                                        {renderItemContent(item)}
                                    </button>
                                    {item.confirm && item === selectedItem && <ConfirmModal item={selectedItem} isOpen={modalOpen} onCancel={cancelModal} onConfirm={confirmModal} />}
                                    {item.form && item === selectedItem && <FormModal item={selectedItem} isOpen={modalOpen} onCancel={cancelModal} onSubmit={formModalSubmit} />}
                                </>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        )
    );
};

export default Dropdown;
